import { consoleLogger } from '../logging/consoleLogger';

export const createCookie = ({
  name,
  value,
  days = 90,
  path = '/',
  domain = '',
}: {
  name: string;
  value: string;
  days?: number;
  path?: string;
  domain?: string;
}) => {
  if (!name || value === null || value === undefined || value === '') {
    return '';
  }
  const expirationDate = new Date();
  expirationDate.setTime(expirationDate.getTime() + days * 24 * 60 * 60 * 1000); // In milliseconds
  const expirationString = expirationDate.toUTCString();
  const pathString = path ? ` path=${path};` : '';
  const domainString = domain ? ` domain=${domain};` : '';
  const cookie = `${name}=${value}; expires=${expirationString};${pathString}${domainString}`;

  consoleLogger.logDebug(`Returning new cookie value: ${cookie}`);
  return cookie;
};
